import React from "react"
import PropTypes from "prop-types"
import Section from "components/Section"
import Type from "components/Type"
import Typography from "@material-ui/core/Typography"
import { withStyles } from "@material-ui/core/styles"

const styles = theme => ({
	types: {
		margin: `0 ${theme.spacing ( -2 )}px`,
		marginTop: theme.spacing ( 2 )
	}
})

class TypographySection extends React.Component {

	render () {
		const { classes, theme } = this.props
		const elements = Object.keys ( theme.typography )
			.filter ( e => theme.typography [ e ].constructor.name === "Object" )
		return <Section id="typography" >
			<Typography variant="h5" >Typography</Typography>
			<div className={classes.types} >
			{
				elements.map ( element => <Type
					key={element}
					variant={element}
				/> )
			}
			</div>
		</Section>
	}

}

TypographySection.propTypes = {
	classes: PropTypes.object.isRequired
}

export default withStyles ( styles, { withTheme: true } ) ( TypographySection )
